export const contactsHeaderTitles = {
  title: 'Contacts',
  orderBtn: 'Commander',
};
